export const focusTableCell = (cell: HTMLTableCellElement) => {
    const selection = window.getSelection();
    const range = document.createRange();

    range.selectNodeContents(cell);
    range.collapse(true);
    selection?.removeAllRanges();
    selection?.addRange(range);
};

export const getColumnCount = (table: HTMLTableElement) =>
    Math.max(...Array.from(table.rows).map((row) => row.cells.length));

export const createEmptyTableCell = () => {
    const cell = document.createElement("td");
    cell.innerHTML = "<br>";
    return cell;
};
